import { selectCurrentUser } from '../redux/slices/session'
import { SessionMetadataUser } from '../types/responses/session-metadata'
import useAppSelector from './useAppSelector'

export function useCurrentUser(): SessionMetadataUser | undefined {
  return useAppSelector(selectCurrentUser)
}
